/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Ai_Document_Unavailable_ErrorInputs */

const en_read_along_ai_document_unavailable_error = /** @type {(inputs: Read_Along_Ai_Document_Unavailable_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI insights are unavailable for this document.`)
};

const es_read_along_ai_document_unavailable_error = /** @type {(inputs: Read_Along_Ai_Document_Unavailable_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La información con IA no está disponible para este documento.`)
};

/**
* | output |
* | --- |
* | "AI insights are unavailable for this document." |
*
* @param {Read_Along_Ai_Document_Unavailable_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_ai_document_unavailable_error = /** @type {((inputs?: Read_Along_Ai_Document_Unavailable_ErrorInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Ai_Document_Unavailable_ErrorInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_ai_document_unavailable_error(inputs)
	return en_read_along_ai_document_unavailable_error(inputs)
});